import {apiSlice} from './apiSlice';

/**
 * Endpoints tool Theo dõi thứ hạng SERP (#6 — §8 bước 2, qua DataForSEO SERP).
 *
 * Vị trí THẬT theo Desktop/Mobile + quốc gia (khác Rank Tracking v1 GSC trung bình). Kiểm
 * tra chạy NỀN (scheduler + tick) → sau khi thêm/kiểm, FE refetch danh sách (poll nhẹ khi
 * còn từ khoá chưa có vị trí). Snapshot SERP dùng chung xuyên user → đối thủ 0đ.
 *
 * Tag 'RankKeyword' theo dự án cho danh sách; history/serp là query-only.
 */
export const rankApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRankKeywords: builder.query({
			query: (projectId) => ({url: `rank/projects/${projectId}`, method: 'get'}),
			transformResponse: (body) => body?.data || {items: [], options: {locations: [], devices: []}, quota: {}},
			providesTags: (result, error, projectId) => [{type: 'RankKeyword', id: `project-${projectId}`}],
		}),
		addRankKeywords: builder.mutation({
			query: ({projectId, keywords, device, location_code}) => ({
				url: `rank/projects/${projectId}`,
				method: 'post',
				data: {keywords, device, location_code},
			}),
			transformResponse: (body) => body?.data || null,
			// Thêm xong trừ quota (nếu enqueue) → cập nhật Subscription; refetch danh sách.
			invalidatesTags: (result, error, {projectId}) => [
				{type: 'RankKeyword', id: `project-${projectId}`},
				'Subscription',
			],
		}),
		deleteRankKeyword: builder.mutation({
			query: ({projectId, trackedId}) => ({url: `rank/projects/${projectId}/${trackedId}`, method: 'delete'}),
			invalidatesTags: (result, error, {projectId}) => [{type: 'RankKeyword', id: `project-${projectId}`}],
		}),
		checkRankNow: builder.mutation({
			query: (projectId) => ({url: `rank/projects/${projectId}/check`, method: 'post'}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, projectId) => [
				{type: 'RankKeyword', id: `project-${projectId}`},
				'Subscription',
			],
		}),
		getRankHistory: builder.query({
			query: ({projectId, trackedId}) => ({url: `rank/projects/${projectId}/history/${trackedId}`, method: 'get'}),
			transformResponse: (body) => body?.data || {series: []},
		}),
		getRankSerp: builder.query({
			query: ({projectId, trackedId}) => ({url: `rank/projects/${projectId}/serp/${trackedId}`, method: 'get'}),
			transformResponse: (body) => body?.data || {has_snapshot: false},
		}),
	}),
});

export const {
	useGetRankKeywordsQuery,
	useAddRankKeywordsMutation,
	useDeleteRankKeywordMutation,
	useCheckRankNowMutation,
	useGetRankHistoryQuery,
	useGetRankSerpQuery,
} = rankApiSlice;
